import { BrowserRouter as Router, Routes, Route } from "react-router";
import Document from "../../Container/Doc/Document";
import Index from "../../Container/Index/Index";
import AboutUs from "../../Container/AboutUs/AboutUs";
import ScrollToTop from "./ScrollToTop";
import News from "../../Container/News/News";
import SocialService from "../../Container/Service/SocialService";
import SocialDuty from "../../Container/Duty/SocialDuty";
import TheirStory from "../../Container/Story/TheirStory";
import JoinUs from "../../Container/JoinUs/JoinUs";
import ShortTermTemporary from "../../Container/Service/ShortTermTemporary";
import BusReserved from "../../Container/Service/BusReserved";
import DistressAssistance from "../../Container/Service/DistressAssistance";
import Happiness from "../../Container/Service/Happiness";
import DreamPlan from "../../Container/Service/DreamPlan";
import Payment from "../../Container/Payment/Payment";
import Info from "../../Container/Payment/Info";
import Summary from "../../Container/Payment/Summary";
import NewsInfo from "../../Container/News/NewsInfo";
import News5 from "../../Container/News/Item/News5";
import News4 from "../../Container/News/Item/News4";
import BindCases from "../../Container/Payment/BindCases";
import Repair from "../../Container/System/Repair";

const Routers = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<Document />} path={`/document`}></Route>
        <Route element={<Index />} path={`/`}></Route>

        <Route element={<AboutUs />} path={`/aboutus`}></Route>

        <Route element={<News />} path={`/news`}></Route>
        <Route element={<News5 />} path={`/news/5`}></Route>
        <Route element={<News4 />} path={`/news/4`}></Route>
        {/* <Route element={<News3 />} path={`/news/3`}></Route>
        <Route element={<News5 />} path={`/news/5`}></Route>
        <Route element={<News5 />} path={`/news/5`}></Route> */}

        <Route element={<SocialService />} path={`/service`}></Route>

        <Route element={<ShortTermTemporary />} path={`/service/短期臨托`} />
        <Route element={<BusReserved />} path={`/service/長照巴士預約`} />
        <Route
          element={<DistressAssistance />}
          path={`/service/長照居家困境協助`}
        />
        <Route element={<Happiness />} path={`/service/幸福二之一`} />
        <Route element={<DreamPlan />} path={`/service/偏鄉身障圓夢計畫`} />

        <Route element={<SocialDuty />} path={`/duty`}></Route>
        <Route element={<TheirStory />} path={`/story`}></Route>
        <Route element={<JoinUs />} path={`/join`}></Route>

        <Route element={<Payment />} path={`/payment_temp`}></Route>
        <Route element={<Summary />} path={`/payment_temp/summary`}></Route>
        <Route element={<Info />} path={`/payment_temp/info`}></Route>
        <Route element={<BindCases />} path={`/bind`}></Route>
        <Route element={<Repair />} path={`/systemRepair`}></Route>

      </Routes>
    </Router>
  );
};

export default Routers;
